import { IdcardOutlined } from "@ant-design/icons";
import { Menu } from "antd";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCrops } from "../API";

function SideMenu() {  
  const location = useLocation();
  const pathName = location.pathname;  

  const [selectedKeys, setSelectedKeys] = useState(pathName);
  const [menuitems, setmenuitems] = useState([]);  

  useEffect(() => {  

    getCrops().then((res) => {
      const lstcrops = res.map((crop) => {
        return {
          label: crop.name,
          icon: <IdcardOutlined  />,
          key:  `/farmer/${crop.id}`,                          
        };                        
      });
      setmenuitems(lstcrops); 
    });    
  }, []);

  const navigate = useNavigate();
  return (
    <div className="SideMenu">
      <Menu
        className="SideMenuVertical"
        mode="vertical"
        onClick={(item) => {          
          navigate(item.key);
          setSelectedKeys(item.key);  
        }}
        selectedKeys={selectedKeys}
        items={menuitems}        
        
      ></Menu>
      
    </div>
  );
}
export default SideMenu;
